import React, { FC } from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { CustomText } from '../customText';
import { TextComponentDeciderProps } from './types/textComponentDecider.types';
import DictionaryTerm from '../dictionaryTerm';

const TextComponentDecider: FC<TextComponentDeciderProps> = (props) => {
  const { type, onClick, ...restOfProps } = props;

  if (type === 'CustomText') {
    return <CustomText {...restOfProps} />;
  } else if (type === 'RichText') {
    return <RichText {...(restOfProps as any)} onClick={onClick} />;
  } else if (type === 'DictionaryTerm') {
    if (props?.dictionaryKey) {
      return (
        <DictionaryTerm
          customTextClass={props?.className}
          keyword={props.dictionaryKey || ''}
          isCustomText={true}
          customTextTag={props.tag}
        />
      );
    }
    return null;
  }
  return <Text {...restOfProps} />;
};

export default TextComponentDecider;
